import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { inject as service } from "@ember/service"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type ModalManager from "cc-frontend/services/modal-manager"
import type Session from "cc-frontend/services/session"

@tagName("")
export default class StandardsTrackerMenuComponent extends Component {
  // Args
  courses!: Array<Course>
  planbook!: Planbook
  closeMenu!: Function

  // Services
  @service session!: Session
  @service modalManager!: ModalManager
}
